import React from 'react';
import { motion } from 'framer-motion';
export function MidCTA() {
  const scrollToForm = () => {
    document.getElementById('form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-[#1e3a4a]" data-id="element-228">
      <div className="container mx-auto px-4" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-231">
            Prepustite nam skrb za prodajo vašega vozila.
          </h2>
          <p className="text-lg text-white/80 mb-6" data-id="element-232">
            Brez stresa, brez pogajanj, brez izgube časa.
          </p>
          <button onClick={scrollToForm} className="px-8 py-3.5 bg-[#1EB6E8] text-white rounded-md font-medium hover:bg-[#1aa3d1] transition-colors text-lg" data-id="element-233">
            Prodaj vozilo
          </button>
          <p className="text-sm text-white/60 mt-3" data-id="element-234">
            Brez obveznosti • Odgovor v 72 urah
          </p>
        </motion.div>
      </div>
    </section>;
}